@import '../../common/common.scss';

:host {
  display: flex;
  flex-direction: column;
  background-color: var(--white-layout-301-level-0-elevation);
}

.page__header {
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  line-height: 33px;
}
